import { render } from "./TemaTrygghetOgSikkerhet.vue?vue&type=template&id=c3fb444e"
import script from "./TemaTrygghetOgSikkerhet.vue?vue&type=script&lang=js"
export * from "./TemaTrygghetOgSikkerhet.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__